/* eslint-disable jira/filename-case */
export const TEAM_NAME = 'jsm-nebula';
export const TOPICS_PAGE_SIZE = 10;
export const PACKAGE_NAME = '@jira/servicedesk__knowledge-performance';
